import { Text } from '@tonic-one/react';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useUtcOffsetStore } from 'src/models/useUtcOffsetModel';
import { formatTableTopX } from 'src/utils/table';

import TableTemplate from '../../Charts/TableTemplate';
import DashboardCard from '../../Layout/DashboardCard';
import RedirectLink from '@Components/RedirectLink';
import { generateRedirectUrlToLog } from '@Log/shared';
import { getServiceNamesByValues } from '@Utils/service';
import { useDashboardServicesStore } from '@Models/useDashboardServicesModel';
import { LogTypeEnum } from '@Types/log';

const QuishingTop5Senders = (props: { data: any; day: string }) => {
  const { t } = useTranslation();
  const timeModel = useUtcOffsetStore();
  const servicesModel = useDashboardServicesStore();
  const config = [
    { width: '29%', grow: 1, align: 'left', tooltip: true },
    { width: '15%', grow: 0, align: 'right' },
    { width: '30%', grow: 1, align: 'left', tooltip: true },
    { width: '20%', grow: 0, align: 'left', tooltip: true },
  ];
  const header = [
    t('dashboard.chart.column.sender'),
    t('dashboard.chart.column.detections'),
    t('dashboard.chart.column.subject'),
    t('dashboard.chart.column.lastDetected'),
  ];

  // const transKey = (data: any) => {
  //   const rawData = data?.quishingTopEmailSender?.[props.day];
  //   if (rawData) {
  //     rawData.forEach((item: any) => {
  //       if (item.key.includes('<') && item.key.includes('>')) {
  //         item.key = item.key.split('<')[1].replace('>', '');
  //       }
  //     });
  //     return rawData;
  //   }
  // };

  const data = formatTableTopX(
    props.data?.quishingTopEmailSender?.[props.day],
    ['key', 'total', 'subject', 'last_detected'],
    t,
    timeModel.offset
  ).map((row) => [
    row[0],
    row[1] === 0 ? (
      0
    ) : (
      <RedirectLink
        href={`logs?${generateRedirectUrlToLog(
          [
            {
              field: 'mergedSecurityRiskName',
              values: ['VAN_QUISHING.UMXX', 'QUISHING'],
              type: 'match',
            },
            {
              field: 'msgFrom',
              values: [row[0] as string],
              type: 'terms',
            },
            {
              field: 'scanSource',
              values: getServiceNamesByValues(servicesModel.enabledServices),
              type: 'terms',
            },
          ],
          props.day,
          LogTypeEnum.DETECTION
        )}`}
      >
        <Text>{row[1]}</Text>
      </RedirectLink>
    ),
    row[2],
    row[3],
  ]);

  return (
    <DashboardCard
      title={t('dashboard.chart.title.quishingTop5Senders.content')}
      iconContent={t('dashboard.chart.title.quishingTop5Senders.tooltip')}
    >
      <TableTemplate config={config} header={header} data={data} />
    </DashboardCard>
  );
};

export default React.memo(QuishingTop5Senders);
